export const getUserLogins = state => state.userLogins.getIn(['all', 'objects'])
